module.exports = __webpack_public_path__ + "static/media/traumatologica.3eb8f31c.svg";